export default __webpack_public_path__ + "static/media/deco-result1.83757542.png";